type SliderFormTextProps = {
  text: string;
};

const SliderFormText = ({ text }: SliderFormTextProps) => {
  return <div className="text-neutral-dark-75">{text}</div>;
};

export default SliderFormText;
